import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/Ausencias/ausensias';
import AusenciasGrid from './AusenciasGrid';

const mstp = state => {
    return {...state.ausencias ,permisos: state.login.me.permisos, }
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(AusenciasGrid)


